import { render, staticRenderFns } from "./titleText.vue?vue&type=template&id=a987985c&scoped=true&"
import script from "./titleText.vue?vue&type=script&lang=js&"
export * from "./titleText.vue?vue&type=script&lang=js&"
import style0 from "./titleText.vue?vue&type=style&index=0&id=a987985c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a987985c",
  null
  
)

component.options.__file = "titleText.vue"
export default component.exports